import { useMutation } from "react-query";
import { useApiError } from "src/hooks/useApiError";
import { createServicePromotionAskV2 } from "src/service/pay";

interface IUseCreateServicePromotionAskProps {
  onSuccess?: () => void;
  onError?: () => void;
}

// 프리미엄코드 문의하기 요청
const useCreateServicePromotionAsk = ({
  onSuccess,
  onError,
}: IUseCreateServicePromotionAskProps) => {
  const { handleError } = useApiError();
  const { mutate: promotionAsk, isLoading: isPromotionAskLoading } =
    useMutation({
      mutationFn: createServicePromotionAskV2,
      onSuccess: onSuccess ? onSuccess : (res) => {},
      onError: onError ? onError : handleError,
    });
  return { promotionAsk, isPromotionAskLoading };
};

export default useCreateServicePromotionAsk;
